// Строка таблицы планировок

import classJoin from 'classjoin';
import {Component, h} from 'preact';

/**
 * Component Properties
 */
interface TableRowProps
{
	/** ID в базе */
	id: number;
	/** Секция */
	section: string;
	/** Этаж */
	floor: number;
	/** Тип комнат */
	roomType: string;
	/** Общая площадь, м^2 */
	squareTotal: number;
	/** Общая цена */
	totalCost: number;
	/** Базовая цена */
	baseCost: number;
	/** Файл планировки квартиры */
	image: string;
}

/**
 * Component State
 */
interface TableRowState
{
	[key: string]: void;
}

/**
 * Строка таблицы планировок
 */
class TableRow extends Component<TableRowProps, TableRowState>
{
	/**
	 * Отформатировать цену
	 * 
	 * @param value Сумма
	 * @returns Строка для вывода
	 */
	private static formatMoney( value: number ): string
	{
		return value.toFixed( 0 ).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ' );
	}
	
	/**
	 * Render component
	 */
	public render(
		{id, section, floor, roomType, squareTotal, totalCost, baseCost, image}: TableRowProps,
	): JSX.Element
	{
		const roomTypeNum = roomType.replace( /\s.+/, '' );
		const roomTypeText = roomType.replace( /^[^(]+/, '' );
		// TODO: Показывать миниатюры.
		const imageUri = `/images/apartments/plans/${
			image.replace( /\.\w+$/, '' )}.png`;
		
		return (
			<tr>
				<td class="image">
					<img src={imageUri} alt="Планировка" />
				</td>
				<td class="room-type">
					{roomTypeNum}{' '}
					{
						roomTypeText
						? <small>{roomTypeText}</small>
						: ''
					}
				</td>
				<td class="square-total">
					{String( squareTotal ).replace( '.', ',' )}
				</td>
				<td class="section">
					{section} секция
				</td>
				<td class="floor">
					{floor}
				</td>
				<td class={
						classJoin(
							{
								empty: ( totalCost === 0 ),
							},
							['total-cost'],
						)
					}
				>
					<ul>
						<li data-label="100% оплата/Базовая ипотека">
							{
								( totalCost > 0 )
								? TableRow.formatMoney( totalCost ) + ' ₽'
								: 'По запросу'
							}
						</li>
						{
							( baseCost > 0 && baseCost !== totalCost )
							? <li data-label="Ипотека 4,7%">
								{TableRow.formatMoney( baseCost ) + ' ₽'}
							</li>
							: ''
						}
					</ul>
				</td>
				<td class="other">
					<a class="more" href={`/choose/apartment/${id}/`}>
						Подробнее
					</a>
					<span class="favorites">
						<input
							type="checkbox"
							id={`apartment-${id}-favorites`}
							value={String( id )}
						/>
						<label for={`apartment-${id}-favorites`}>
							<svg role="img" width="20" height="20" viewBox="0 0 20 20" title="Добавить в избранное">
								<title>Добавить в избранное</title>
								<path d="M10 15.7l-5.6 2.9 1.1-6.2L1 8l6.2-.9L10 1.5l2.8 5.6L19 8l-4.5 4.4 1.1 6.2z"/>
							</svg>
						</label>
					</span>
				</td>
			</tr>
		);
	}
}

/**
 * Module
 */
export {
	TableRow as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/TableRow.tsx